"use client"

import { useState, useEffect } from "react"
import HorizontalScrollMenu from "./Components/HorizontalScrollMenu"
import MenuSection from "./Components/MenuSection"
import { useCart } from "../CartContent"
import Navbar from "./Components/Navbar"
import Footer from "./Components/Footer"
import { API_BASE_URL } from "../config"

export default function Menu() {
  const { cartItems } = useCart()
  const totalQuantity = cartItems.reduce((sum, item) => sum + item.quantity, 0)

  const categories = [
    "Make Your Own Bowl",
    "Make Your Own Wrap",
    "Parsley Bowls",
    "Parsley Wraps",
    "Appetizers",
    "Salads",
    "Charcoal Grill",
    "Family Platters",
    "Sandwiches",
    "Pastries",
    "Desserts",
    "Beverages",
  ]

  const [allMenuItems, setAllMenuItems] = useState([])
  const [selectedCategory, setSelectedCategory] = useState(categories[0])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    async function fetchMenu() {
      try {
        setLoading(true)
        setError(null)

        const res = await fetch(`${API_BASE_URL}/api/menu`)
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`)

        const data = await res.json()
        console.log("Raw menu data from backend:", data)

        setAllMenuItems(data.objects || [])
      } catch (err) {
        console.error("Error fetching menu:", err)
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }
    fetchMenu()
  }, [])

  // Filter items by selected category - now working with Square API structure
  const filteredItems = Array.isArray(allMenuItems)
    ? allMenuItems.filter((item) => item.type === "ITEM" && item.item_data?.categoryNames?.includes(selectedCategory))
    : []

  console.log("Filtered items for category:", selectedCategory, filteredItems)

  return (
    <div className="bg-[#F5F5DC] min-h-screen">
      {/* Navbar */}
      <Navbar totalQuantity={totalQuantity} />

      {/* Header Section */}
      <section className="w-full px-4 sm:px-6 md:px-8 lg:px-16 py-6 md:py-8 bg-orange-400">
        <div className="max-w-7xl mx-auto flex flex-col items-start gap-6 md:gap-8">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight md:leading-snug">
            Taste the Tradition
          </h1>
          <p className="text-base md:text-lg max-w-3xl">
            Dive into our menu and discover the rich, authentic flavors of Syrian BBQ.
          </p>
        </div>
      </section>

      {/* Menu Content */}
      <section className="w-full px-4 sm:px-6 md:px-8 lg:px-16 py-4 md:py-8 bg-orange-400">
        <div className="max-w-7xl mx-auto">
          {/* Categories Scroll */}
          <div className="w-full p-4 md:p-5 mb-12 shadow-md outline outline-1 outline-black">
            <HorizontalScrollMenu
              menuItems={categories}
              onItemClick={setSelectedCategory}
              selectedItem={selectedCategory}
            />
          </div>

          {/* Error State */}
          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
              Error loading menu: {error}
            </div>
          )}

          {/* Menu Section */}
          <MenuSection
            title={selectedCategory}
            heading={`Our delicious ${selectedCategory.toLowerCase()}`}
            items={loading ? [] : filteredItems}
            loading={loading}
          />
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  )
}
